export enum EJournalRubricsLabel {
  MAIN = 'Главная',
}
